import { Injectable, inject } from '@angular/core';

import { LocaleService } from '../locale/locale.service';
import type { LocaleDetails } from '../locale/locale.domain';

/**
 * Locale specific number parser
 */
@Injectable({
  providedIn: 'root'
})
export class NumberParserService {
  private readonly localeService = inject<LocaleService>(LocaleService);

  private readonly groupSeparatorRegularExpression: RegExp;
  private readonly decimalsSeparatorRegularExpression: RegExp;
  private readonly currencySymbolRegularExpression: RegExp;

  constructor() {
    const localeDetails: LocaleDetails = this.localeService.getLocaleDetails();
    this.groupSeparatorRegularExpression = new RegExp('\\' + localeDetails.groupSeparator, 'g');
    this.decimalsSeparatorRegularExpression = new RegExp('\\' + localeDetails.decimalSeparator, 'g');
    this.currencySymbolRegularExpression = new RegExp('\\' + localeDetails.currencySymbol, 'g');
  }

  /**
   * Parses string representations of numbers in English or French based on current locale
   * Should be used to parse values entered by user in the forms
   *
   * @param floatString representation of number
   * @returns
   */
  parse(floatString: string): number {
    floatString = floatString.replace(this.groupSeparatorRegularExpression, '');
    floatString = floatString.replace(this.currencySymbolRegularExpression, '');
    // replace spaces for all locales to keep functionality in line with to globalize
    floatString = floatString.replace(/\s/g, '');
    floatString = floatString.replace(this.decimalsSeparatorRegularExpression, '.');
    return Number(floatString);
  }
}
